import { REMOVE_USER_EMAIL_REQUEST, REMOVE_USER_EMAIL_SUCCESS, REMOVE_USER_EMAIL_FAILURE } from '../../constants/user_emails.constants';

export const removeUserEmailRequest = (email_id, user_id) => ({ type: REMOVE_USER_EMAIL_REQUEST, email_id, user_id });
export const removeUserEmailRequestSuccess = payload => ({ type: REMOVE_USER_EMAIL_SUCCESS, payload });
export const removeUserEmailRequestFailure = error => ({ type: REMOVE_USER_EMAIL_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_emails_actions/remove_user_email.actions.js